/**
 * Creatify Aurora —— capability 元数据
 */
export default {
  id: 'creatify-aurora',
  nodeType: 'video',
  label: 'Creatify Aurora',
  description: '输入人物图片和音频，生成高保真棚拍口播视频。',
}
